import { useKcUrlEffect } from 'effects/url-effects';
import { openUrl } from 'utils/url-utils';

export default function AppPageExpiredFlow() {
  const loginRestartFlowUrl = useKcUrlEffect('loginRestartFlowUrl');

  openUrl(loginRestartFlowUrl);

  return null;
}
